import ActionsListPresumedUnavailability from 'cancellations/components/search/action-cancellation-presumed-unavailability';
import { CancellationAirePresumedUnavailabilitySearchCrumbs } from 'cancellations/constants/cancellation-aire-presumed-unavailabilty-crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';

const CancellationAirePresumedUnavailabilitySearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CancellationAirePresumedUnavailabilitySearchCrumbs} />
      <PersonSearch
        pathname="/cancellazioni/cancellazione-aire/irreperibilita-presunta/cancellazione"
        action={ActionsListPresumedUnavailability}
        isAire
        addedTitle="- Cancellazione da AIRE per Irreperibilità Presunta"
      />
    </Fragment>
  );
};

CancellationAirePresumedUnavailabilitySearchPersonPage.displayName =
  'Cancellation presumed unavailability search person page component';

export default CancellationAirePresumedUnavailabilitySearchPersonPage;
